import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { getMsalConfig } from './authConfig';
import App from './App';

// Clear any corrupted MSAL cache from previous attempts
console.log('Clearing MSAL cache to avoid redirect_uri mismatch...');
const keysToRemove = [];
for (let i = 0; i < localStorage.length; i++) {
  const key = localStorage.key(i);
  if (key && key.includes('msal')) {
    keysToRemove.push(key);
  }
}
keysToRemove.forEach(key => {
  console.log('Removing cached key:', key);
  localStorage.removeItem(key);
});

// Create MSAL instance with runtime config
const redirectUri = window.location.hostname === 'localhost'
  ? window.location.origin
  : 'https://calendar.cloudappi.net';
console.log('Creating MSAL instance with redirectUri:', redirectUri);
console.log('Current window.location:', {
  href: window.location.href,
  origin: window.location.origin,
  hostname: window.location.hostname,
  protocol: window.location.protocol
});

const msalInstance = new PublicClientApplication(getMsalConfig());

// Handle redirect promise before rendering
msalInstance.handleRedirectPromise()
  .then((response) => {
    if (response) {
      console.log('Redirect response received:', response);
    } else {
      console.log('No redirect response (normal page load)');
    }
    // Render app after handling redirect
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
        <App msalInstance={msalInstance} />
      </React.StrictMode>
    );
  })
  .catch((error) => {
    console.error('Redirect error details:', {
      name: error.name,
      message: error.message,
      errorCode: error.errorCode,
      errorMessage: error.errorMessage,
      subError: error.subError
    });
    // Render app even if there's an error
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
        <App msalInstance={msalInstance} />
      </React.StrictMode>
    );
  });
